/* Project Import will be here */
import { post, IRequest } from "./index";
import { ISearchProductParams } from "models/homeModels";
/* Project Import will be here */

/* Get product attribute filter and value list */
export const getAttrFilterListApi = (data: ISearchProductParams) => {
    const request: IRequest = {
        subUrl: '/Product/AttributeMaster',
        data
    };

    return post(request);
};